'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import { cn } from '@core/utils';
import useEmblaCarousel from 'embla-carousel-react';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { BREAKPOINTS } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useSelectedSnapIndex } from '@/hooks/useSelectedSnapIndex';
interface DesktopMainBannerSectionProps {
  bannerItems: {
    href: string;
    title: string;
    imageUrl: string;
    target?: string;
  }[];
  className?: string;
}
export const DesktopMainBannerSection = t0 => {
  const $ = _c(40);
  const {
    bannerItems,
    className
  } = t0;
  const isDesktop = useMediaQuery(BREAKPOINTS.DESKTOP);
  const t1 = bannerItems.length > 1;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      loop: t1,
      align: "center"
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t2);
  const isSwiperReady = Boolean(emblaApi);
  const activeIndex = useSelectedSnapIndex(emblaApi);
  const bannerImageWidth = isDesktop ? BANNER_WIDTH_DESKTOP : BANNER_WIDTH_MOBILE;
  const bannerImageHeight = isDesktop ? BANNER_HEIGHT_DESKTOP : BANNER_HEIGHT_MOBILE;
  const swiperWidth = bannerImageWidth * MIN_BANNER_LENGTH + SWIPER_GAP * (MIN_BANNER_LENGTH - 1);
  let t3;
  bb0: {
    if (bannerItems.length === 0 || bannerItems.length > MIN_BANNER_LENGTH) {
      t3 = bannerItems;
      break bb0;
    }
    const targetLength = MIN_BANNER_LENGTH * 2;
    let t4;
    if ($[2] !== bannerItems) {
      t4 = Array.from({
        length: targetLength
      }, (_, index) => bannerItems[index % bannerItems.length]);
      $[2] = bannerItems;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    t3 = t4;
  }
  const list = t3;
  const totalUniqueItems = bannerItems.length;
  const paginationIndex = activeIndex % bannerItems.length;
  if (bannerItems.length < 1) {
    return null;
  }
  let t4;
  if ($[4] !== className) {
    t4 = cn("w-fit max-w-full", "mobile-tablet:w-full", className);
    $[4] = className;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = isDesktop ? "desktop" : "mobile";
  let t6;
  if ($[6] !== bannerItems.length || $[7] !== paginationIndex || $[8] !== totalUniqueItems) {
    t6 = bannerItems.length > 1 && <div className="pointer-events-none absolute z-10 hidden mobile-tablet:block" style={{
      bottom: 12,
      right: `calc((100% - ${BANNER_WIDTH_MOBILE}px) / 2 + 12px)`
    }}><div className="h-20 w-36 whitespace-nowrap rounded-pill bg-Gray-black/20 font-600 text-Gray-white flex-center typo-caption2">{`${paginationIndex + 1} / ${totalUniqueItems}`}</div></div>;
    $[6] = bannerItems.length;
    $[7] = paginationIndex;
    $[8] = totalUniqueItems;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = !isSwiperReady && "opacity-0";
  let t8;
  if ($[10] !== t7) {
    t8 = cn("max-w-full overflow-hidden", t7);
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = `${swiperWidth}px`;
  let t10;
  if ($[12] !== t9) {
    t10 = {
      width: t9
    };
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== activeIndex || $[15] !== bannerImageHeight || $[16] !== bannerImageWidth || $[17] !== list) {
    let t12;
    if ($[19] !== activeIndex || $[20] !== bannerImageHeight || $[21] !== bannerImageWidth) {
      t12 = (t13, index_0) => {
        const {
          href,
          imageUrl,
          title,
          target
        } = t13;
        return <div key={`${href}-${index_0}`} className="flex-[0_0_auto]" style={{
          width: bannerImageWidth,
          minWidth: 0,
          marginRight: `${SWIPER_GAP}px`
        }}><CustomLink href={href} target={target} aria-label={`${title} 상세페이지로 이동`} className={cn("rounded-large transition-opacity duration-200 ease-out", "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-B-500", "active:opacity-80", "xl:hover:opacity-80", "mobile-tablet:w-full")}><div className={cn("relative overflow-hidden rounded-large", "transition-opacity duration-300", activeIndex === index_0 ? "opacity-100" : "mobile-tablet:opacity-50")} style={{
              width: bannerImageWidth,
              height: bannerImageHeight
            }}><Image src={imageUrl} fill={true} sizes={`${BREAKPOINTS.MOBILE_TABLET} 335px, 502px`} alt={`${title}에 관한 배너 이미지`} className="rounded-large object-cover" preload={index_0 === 0} /></div></CustomLink></div>;
      };
      $[19] = activeIndex;
      $[20] = bannerImageHeight;
      $[21] = bannerImageWidth;
      $[22] = t12;
    } else {
      t12 = $[22];
    }
    t11 = list.map(t12);
    $[14] = activeIndex;
    $[15] = bannerImageHeight;
    $[16] = bannerImageWidth;
    $[17] = list;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = <div className="flex">{t11}</div>;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== emblaRef || $[26] !== t10 || $[27] !== t12 || $[28] !== t8) {
    t13 = <div ref={emblaRef} className={t8} style={t10}>{t12}</div>;
    $[25] = emblaRef;
    $[26] = t10;
    $[27] = t12;
    $[28] = t8;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== isSwiperReady) {
    t14 = !isSwiperReady && <div className="absolute inset-0 z-20 flex justify-center xl:hidden"><Skeleton className="h-120 w-[335px] rounded-large" /></div>;
    $[30] = isSwiperReady;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t13 || $[33] !== t14 || $[34] !== t6) {
    t15 = <div className="relative">{t6}{t13}{t14}</div>;
    $[32] = t13;
    $[33] = t14;
    $[34] = t6;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t15 || $[37] !== t4 || $[38] !== t5) {
    t16 = <section className={t4} key={t5}>{t15}</section>;
    $[36] = t15;
    $[37] = t4;
    $[38] = t5;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  return t16;
};
const BANNER_WIDTH_DESKTOP = 502;
const BANNER_WIDTH_MOBILE = 335;
const BANNER_HEIGHT_DESKTOP = 180;
const BANNER_HEIGHT_MOBILE = 120;
const MIN_BANNER_LENGTH = 5;
const SWIPER_GAP = 10;